const participationTypeEnum = {
  FaceToFace: 1,
  Alternate: 2,
  AbsentExcused: 3,
};

export default participationTypeEnum;
